import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { compare } from "../../actions/";

class Compare extends Component {
  constructor(props) {
    super(props);
    this.onButtonClick = this.onButtonClick.bind(this);
  }
  onButtonClick() {
    this.props.compare({ segments: this.props.segments });
  }
  render() {
    return (
      <button
        onClick={this.onButtonClick}
        className="btn btn-success"
        title="Vérifier si le tracé est bien identique modèle"
      >
        <span className="glyphicon glyphicon-ok" />
      </button>
    );
  }
}

Compare.propTypes = {
  compare: PropTypes.func.isRequired,
  segments: PropTypes.shape().isRequired
};
const mapStateToProps = ({ activeModele, trace }) => ({
  segments: { modele: activeModele.segments, copie: trace.segments }
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ compare }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Compare);
